<script setup>
import { useRuntimeStore } from "@/stores/runtime";
const runtimeStore = useRuntimeStore();
import AlertComponent from "@/components/AlertComponent.vue";
import { useRouter } from "vue-router";
import { onMounted, onUnmounted } from "vue";

const router = useRouter();

onMounted(() => {
  router.beforeEach(() => {
    if (runtimeStore.hasMessage) {
      runtimeStore.incrementViewCount();
    }
  });
});

onUnmounted(() => {
  router.beforeEach(() => {
    return true;
  });
});
</script>

<template>
  <div class="app-notice" v-if="runtimeStore.hasMessage">
    <div class="app-notice">
      <alert-component :type="runtimeStore.message.type">{{
        runtimeStore.message.message
      }}</alert-component>
    </div>
  </div>
</template>

<style scoped></style>
